import { render, staticRenderFns } from "./CrudStoreTypes.vue?vue&type=template&id=62c8c518&scoped=true"
import script from "./CrudStoreTypes.vue?vue&type=script&lang=js"
export * from "./CrudStoreTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c8c518",
  null
  
)

export default component.exports